const pageNameKey = "timestampsAndStringsDataTable";

export const timestampsAndStringsDataTableEn = {
  [pageNameKey]: {
    noDataAvailable: "No string data available",
    timestampColumnHeaderText: "Timestamp",
    dataColumnHeaderText: "Data",
  },
};

export const timestampsAndStringsDataTablePtBr = {
  [pageNameKey]: {
    noDataAvailable: "Nenhum dado de string disponível",
    timestampColumnHeaderText: "Data e hora",
    dataColumnHeaderText: "Dados",
  },
};

export const timestampsAndStringsDataTableDe = {
  [pageNameKey]: {
    noDataAvailable: "Keine Zeichendaten verfügbar",
    timestampColumnHeaderText: "Zeitstempel",
    dataColumnHeaderText: "Daten",
  },
};

export const timestampsAndStringsDataTableZhHans = {
  [pageNameKey]: {
    noDataAvailable: "没有可用的字符串数据",
    timestampColumnHeaderText: "时间戳",
    dataColumnHeaderText: "数据",
  },
};

export const timestampsAndStringsDataTableIt = {
  [pageNameKey]: {
    noDataAvailable: "Nessuna stringa disponibile",
    timestampColumnHeaderText: "Timestamp",
    dataColumnHeaderText: "Dati",
  },
};

export const timestampsAndStringsDataTableEs = {
  [pageNameKey]: {
    noDataAvailable: "No hay datos de cadena disponibles",
    timestampColumnHeaderText: "Marca de tiempo",
    dataColumnHeaderText: "Datos",
  },
};

export const timestampsAndStringsDataTableNl = {
  [pageNameKey]: {
    dataColumnHeaderText: "Gegevens",
    noDataAvailable: "Geen tekstgegevens beschikbaar",
    timestampColumnHeaderText: "Tijdstempel",
  },
};

export const timestampsAndStringsDataTableTr = {
  [pageNameKey]: {
    dataColumnHeaderText: "Veri",
    noDataAvailable: "Dize verisi yok",
    timestampColumnHeaderText: "Zaman damgası",
  },
};
